import { useMutation } from "react-query";
import { secureAxios } from "../../_helpers/auth";
import { queryClient } from "../../_helpers/query";

export const usePublishTemplate = (
    onSuccess = () => {},
    onError = () => {},
    onDone
) => {
    return useMutation(
        (newItem) => {
            return (
                secureAxios
                    // .post(`/qp_publish/publish_template`, newItem)
                    .post(`/qe_publish/publish_template`, newItem)
                    .then((res) => res.data)
            );
        },
        {
            onSuccess: (data) => {
                queryClient.invalidateQueries(["items", "qp_creation"]);
                onSuccess(data);
            },
            onError: (error) => {
                onError(error);
            },
            onSettled: () => {
                onDone();
            },
        }
    );
};

export const useUpdateTemplate = (
    onSuccess = () => {},
    onError = () => {},
    onDone
) => {
    return useMutation(
        (newItem) => {
            return (
                secureAxios
                    // .post(`/qp_publish/publish_template`, newItem)
                    .post(
                        `/qe_publish/update_template/${newItem?.id}`,
                        newItem?.data
                    )
                    .then((res) => res.data)
            );
        },
        {
            onSuccess: (data) => {
                queryClient.invalidateQueries([
                    "items",
                    "qdb_creation_template",
                ]);
                onSuccess(data);
            },
            onError: (error) => {
                onError(error);
            },
            onSettled: () => {
                onDone();
            },
        }
    );
};
